import React from 'react';
import styled from 'styled-components';

import { Button, IconArrowRight as ArrowRight } from '../../core';

interface Props {
  className?: string;
  title?: string;
  subtitle?: React.ReactNode;
  buttonName?: string;
  buttonLink?: string;
  category?: boolean;
}

const Hero = ({
  className = '',
  title = '',
  subtitle = '',
  buttonName = '',
  buttonLink = '',
  category = false,
}: Props) => (
  <div className={`${className} ${category && 'hero-category'} `}>
    <div className="hero-desc">
      <h1>{title}</h1>
      {!category && buttonLink && buttonName && (
        <Button
          iconAfter={<ArrowRight />}
          variant="primary"
          size="M"
          onClick={() => (window.location.href = buttonLink)}
        >
          {buttonName}
        </Button>
      )}
      {category && subtitle}
    </div>
  </div>
);

const HeroStyled = styled(Hero)`
  border: 0.0625rem solid ${({ theme }) => theme.neutralBorder};
  border-radius: 0.75rem;
  background: url('/images/hero-image@3x.jpg') center center / cover no-repeat;
  padding: 2rem;
  min-height: 23.0625rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 2.5rem;

  &.hero-category {
    background: url('/images/hero-category@3x.jpg') center center / cover no-repeat;

    .hero-desc {
      max-width: 43.75rem;

      /* H1 SB: the page title of the Updated Branding Styleguide frame (13727:145490). */
      h1 {
        font-size: ${({ theme }) => theme.typography.h1Sb.fontSize};
        font-weight: ${({ theme }) => theme.typography.h1Sb.fontWeight};
        line-height: ${({ theme }) => theme.typography.h1Sb.lineHeight};
        letter-spacing: ${({ theme }) => theme.typography.h1Sb.letterSpacing};
        color: ${({ theme }) => theme.neutralText};
        margin-top: 0;
        margin-bottom: 1rem;
      }

      p {
        font-size: 0.875rem;
        line-height: 1.428571428571429;
        color: ${({ theme }) => theme.neutralTextWeak};
        margin-top: 0;
        margin-bottom: 1.25rem;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  &:not(.hero-category) {
    .hero-desc {
      max-width: 50%;

      h1 {
        font-size: 3rem;
        font-weight: 600;
        line-height: 1.083333333333333;
        color: ${({ theme }) => theme.neutralText};
        margin-top: 0;
        margin-bottom: 1rem;
      }

      p {
        color: ${({ theme }) => theme.neutralTextWeak};
        margin-top: 0;
        margin-bottom: 1.5rem;
      }
    }
  }
`;

export default HeroStyled;
